import { z } from "zod";

const registerSchema = z.object({
	name: z
		.string({ message: "O nome não pode ser vazio!" })
		.min(3, "O nome é muito pequeno, tente novamente!")
		.max(255, "O nome é muito grande, tente novamente!"),
	username: z
		.string({ message: "O user name não pode ser vazio!" })
		.min(3, "O username é muito pequeno, tente novamente!")
		.max(23, "O username e é muito grande, tente novamente!"),
	bio: z.string().nullish(),
	icon: z
		.string()
		.default(
			"http://res.cloudinary.com/ddhbhbxcs/image/upload/v1718593682/dbc9ei7kmiyh5iqhnqly.svg"
		),
	role: z.enum(["user", "admin"]).default("user"),
	image: z.string().nullish(),
	phone: z
		.string({ message: "O telefone não pode ser vazio!" })
		.max(11, "O telefone é muito grande, tente novamente!"),
	email: z
		.string({ message: "O email não pode ser vazio!" })
		.email()
		.max(55, "O email é muito grande, tente novamente!"),
	password: z
		.string({ message: "A senha não pode ser vazia!" })
		.min(6, "O senha é muito pequena, tente novamente!")
		.max(120, "O senha é muito grande, tente novamente!"),
	isTermAccepted: z.boolean(),
});

export type iRegisterData = z.infer<typeof registerSchema>;

export { registerSchema };
